// Whether a business's plan has lapsed. Same rule as Owner Portal's SubscriptionGate.
const BLOCKED = new Set(["inactive", "expired", "suspended"]);

export interface PlanFields {
  subscription_status: string | null;
  subscription_period_end: string | null;
  grace_period_ends_at: string | null;
}

export function planLocked(b: PlanFields, today = new Date().toISOString().slice(0, 10)): boolean {
  const ended = !!b.subscription_period_end && b.subscription_period_end.slice(0, 10) < today;
  const status = ended && (b.subscription_status === "active" || b.subscription_status === "trial") ? "expired" : b.subscription_status ?? "";
  const inGrace = !!b.grace_period_ends_at && b.grace_period_ends_at.slice(0, 10) >= today;
  return BLOCKED.has(status) && !inGrace;
}
